module.exports = __webpack_public_path__ + "static/media/oneMinute-intro.e96ff82d.mp3";